// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2oUrw","selects":"Documents_selects__3tcq0"};